<!-- dispatch-from.component.html
<div class="card mb-4">
  <div class="card-header">
    <h4>Dispatch Form</h4>
  </div>
  <div class="card-body">
    <form [formGroup]="dispatchForm" (ngSubmit)="onSubmit()">
      Add More Dispatch Pair Button
      <button type="button" (click)="addDispatch()" class="btn btn-success mb-3">+</button>
      <button type="button" (click)="removeDispatchDate()" class="btn btn-warning mb-3">x</button>

      <div class="row mb-3">
        <div class="col-md-2">
          <div class="form-group">
            <label for="orderKgs">Order Kgs</label>
            <input type="number" id="orderKgs" formControlName="orderKgs" class="form-control" />
          </div>
        </div>

        Dispatch Fields (Disp1 to Disp12)
        <div class="col-md-9">
          <div formArrayName="dispatches" class="row">
            <div *ngFor="let disp of dispatches.controls; let i = index" [formGroupName]="i" class="col-md-2">
              <div class="form-group">
                <label for="disp{{i}}">{{'Disp' + (i + 1)}}</label>
                <input type="number" id="disp{{i}}" formControlName="disp" class="form-control" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        Dispatched Input
        <div class="col-md-2">
          <div class="form-group">
            <label for="dispatched">Dispatched</label>
            <input type="number" id="dispatched" formControlName="dispatched" class="form-control" />
          </div>
        </div>

        Dispatch Date Fields (Dispatch Date 1 to Dispatch Date 12)
        <div class="col-md-9">
          <!-- <div formArrayName="dispatchDates" class="row"> -->
            <!-- <div *ngFor="let dispDate of dispatchDates.controls; let i = index" [formGroupName]="i" class="col-md-2"> -->
              <!-- <div class="form-group"> -->
                <!-- <label for="dispatchDate{{i}}">{{'Dispatch Date ' + (i + 1)}}</label> -->
                <!-- <input type="date" id="dispatchDate{{i}}" formControlName="dispatchDate" class="form-control" /> -->
              <!-- </div> -->
            <!-- </div> -->
          <!-- </div> -->
        <!-- </div> -->
      <!-- </div> -->

      <!-- Other form fields -->
      <!-- <div class="form-group">
        <label for="kgsBal">Kgs Balance</label>
        <input type="number" id="kgsBal" formControlName="kgsBal" class="form-control" />
      </div>
      <div class="form-group">
        <label for="orderPc">Order PCs</label>
        <input type="number" id="orderPc" formControlName="orderPc" class="form-control" />
      </div>

      <div class="form-group">
        <label for="orderNo">Order No</label>
        <input type="text" id="orderNo" formControlName="orderNo" class="form-control" />
      </div>

      <div class="form-group">
        <label for="refNo">Ref No</label>
        <input type="text" id="refNo" formControlName="refNo" class="form-control" />
      </div>

      <div class="form-group">
        <label for="jobName">Job Name</label>
        <input type="text" id="jobName" formControlName="jobName" class="form-control" />
      </div>

      <div class="form-group">
        <label for="poNumber">PO Number</label>
        <input type="text" id="poNumber" formControlName="poNumber" class="form-control" />
      </div>

      <button type="submit" class="btn btn-primary mt-3" [disabled]="!dispatchForm.valid">Submit</button>
    </form>
  </div>
</div>  -->
<div class="card mb-4">
  <div class="card-header">
    <h4>Dispatch Form</h4>
  </div>
  <div class="card-body">
    <form [formGroup]="dispatchForm" (ngSubmit)="onSubmit()">
      <!-- Add More Dispatch Pair Button -->
      <button type="button" (click)="addDispatch()" class="btn btn-success mb-3">+</button>
      <button type="button" (click)="removeDispatch()" class="btn btn-warning mb-3">x</button>


      <div class="row mb-3">
        <div class="col-md-2">
          <div class="form-group">
            <label for="orderKgs">Order Kgs</label>
            <input type="number" id="orderKgs" formControlName="orderKgs" class="form-control" />
          </div>
        </div>

        <!-- Dispatch Fields (Disp1 to Disp12) -->
        <div class="col-md-9">
          <div formArrayName="dispatchDetails" class="row">
            <div *ngFor="let detail of dispatchDetails.controls; let i = index" [formGroupName]="i" class="col-md-2">
              <div class="form-group">
                <label for="disp{{i}}">{{'Disp' + (i + 1)}}</label>
                <input type="number" id="disp{{i}}" formControlName="disp" class="form-control" />
              </div>
              <div class="form-group">
                <label for="dispatchDate{{i}}">{{'Dispatch Date ' + (i + 1)}}</label>
                <input type="date" id="dispatchDate{{i}}" formControlName="dispatchDate" class="form-control" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Dispatched Field -->
      <div class="row mb-3">
        <div class="col-md-2">
          <div class="form-group">
            <label for="dispatched">Dispatched</label>
            <input type="number" id="dispatched" formControlName="dispatched" class="form-control" />
          </div>
        </div>
      </div>

      <!-- Other form fields -->
      <div class="form-group">
        <label for="kgsBal">Kgs Balance</label>
        <input type="number" id="kgsBal" formControlName="kgsBal" class="form-control" />
      </div>
      <div class="form-group">
        <label for="orderPc">Order PCs</label>
        <input type="number" id="orderPc" formControlName="orderPc" class="form-control" />
      </div>

      <div class="form-group">
        <label for="orderNo">Order No</label>
        <input type="text" id="orderNo" formControlName="orderNo" class="form-control" />
      </div>

      <div class="form-group">
        <label for="refNo">Ref No</label>
        <input type="text" id="refNo" formControlName="refNo" class="form-control" />
      </div>

      <div class="form-group">
        <label for="jobName">Job Name</label>
        <input type="text" id="jobName" formControlName="jobName" class="form-control" />
      </div>

      <div class="form-group">
        <label for="poNumber">PO Number</label>
        <input type="text" id="poNumber" formControlName="poNumber" class="form-control" />
      </div>

      <!-- Submit Button -->
      <button type="submit" class="btn btn-primary mt-3" [disabled]="!dispatchForm.valid">Submit</button>
    </form>
  </div>
</div>
